import { ComponentProps } from "react";
import type ConfirmationModal from "../components/modals/confirmation-modal";
import type PhotoGuideModal from "../components/modals/photo-guide-modal";

export enum EModal {
    CONFIRMATION = 'CONFIRMATION',
    SURVEY_REGISTER = 'SURVEY_REGISTER',
    PHOTO_GUIDE = 'PHOTO_GUIDE',
}

export interface IModalBase {
    canBeClosed?: boolean;
}

export interface IConfirmationModal extends IModalBase {
    key: EModal.CONFIRMATION;
    props: Omit<ComponentProps<typeof ConfirmationModal>, 'modalId'>;
}

export interface IRegisterModal extends IModalBase {
    key: EModal.SURVEY_REGISTER;
    props?: never,
}

export interface IPhotoGuideModal extends IModalBase {
    key: EModal.PHOTO_GUIDE;
    props?: never,
}

export type TModalData = IConfirmationModal | IRegisterModal | IPhotoGuideModal;

export type TModal = TModalData & TModalBaseProps;

export type TModalBaseProps = {
    modalId: number;
}
